import React, {
  FocusEvent,
  RefObject,
  KeyboardEvent,
} from 'react';
import MaskedTextField from 'core/components/MaskedTextField';
import {
  isNilOrZero,
} from '@populateui/utils';

type Props = {
  id?: string;
  value?: string | number | null;
  onChange: (value: string | number | null) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  inputProps?: object;
  inputRef?: RefObject<HTMLInputElement>;
  defaultValue?: string | number | null;
  nullIfEmpty?: boolean;
  placeholder?: string;
};

const durationMask = [
  { mask: '' },
  {
    mask: 'duration minutes',
    overwrite: true,
    lazy: false,
    eager: true,
    blocks: {
      duration: {
        mask: Number,
        min: 0,
        scale: 0,
      },
    },
  },
];

export default function DurationTextField({
  value: _value,
  className,
  onChange,
  onKeyDown,
  ...props
}: Props) {
  const value = isNilOrZero(_value) ? '' : String(_value);

  return (
    <MaskedTextField
      {...props}
      mask={durationMask}
      unmask
      className={className}
      value={value}
      onAccept={onChange}
      maskedPosition={{ start: 0, end: 8 }}
    />
  );
}
